/**
 * Created by hernanherreros on 2019-05-28
 */

export const theme = {
  fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
  space: [
    // margin and padding
    0,
    4,
    8,
    16,
    32,
    64,
    128,
    256,
  ],
  colors: {
    primary: '#6557f5',
    secondary: '#eea94f',
    terciary: '#a3ded9',
    black: '#4b5c6b',
  },
}